import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { TreePine, Lock, User, LogIn } from 'lucide-react';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAdmin();
  const navigate = useNavigate();

  const performLogin = async () => {
    setIsLoading(true);
    try {
      await login(username, password);
      toast.success('Uspešna prijava!');
      navigate('/admin');
    } catch (error) {
      const detail = error?.response?.data?.detail || 'Napačno uporabniško ime ali geslo';
      toast.error(typeof detail === 'string' ? detail : 'Napaka pri prijavi');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    performLogin();
  };

  return (
    <div className="min-h-screen bg-stone-900 flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-stone-800/50 border-stone-700 p-8">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-emerald-600/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <TreePine className="w-8 h-8 text-emerald-400" />
          </div>
          <h1 className="text-2xl font-bold text-white">Admin Panel</h1>
          <p className="text-stone-400 mt-2">Lovska družina Rakek</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <Label htmlFor="username" className="text-stone-300">Uporabniško ime</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-stone-500" />
              <Input
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="pl-10 bg-stone-900/50 border-stone-700 text-white"
                placeholder="admin"
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="password" className="text-stone-300">Geslo</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-stone-500" />
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 bg-stone-900/50 border-stone-700 text-white"
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <Button
            type="submit"
            disabled={isLoading}
            className="w-full bg-emerald-600 hover:bg-emerald-500 text-white"
          >
            {isLoading ? (
              <span className="flex items-center gap-2">
                <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Prijavljam...
              </span>
            ) : (
              <span className="flex items-center gap-2">
                <LogIn className="w-5 h-5" />
                Prijava
              </span>
            )}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <a href="/" className="text-stone-500 hover:text-emerald-400 text-sm transition-colors">
            ← Nazaj na spletno stran
          </a>
        </div>
      </Card>
    </div>
  );
};

export default AdminLogin;
